import React from 'react';
import Container from 'react-bootstrap/Container';

const leadCreationFailedText = {
    header: 'Oops, something went wrong...',
    content: 'Form could not be submitted due to an error.',
};

const LeadCreationError: React.FC = () => {
    return (
        <Container>
            <h1 className="h4">{leadCreationFailedText.header}</h1>
            <p>{leadCreationFailedText.content}</p>
        </Container>
    );
};

export { LeadCreationError, leadCreationFailedText };
